class FloralAnimation {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector(".floral-like-button");
    this.petalsContainer = container.querySelector(".petals-container");
    this.isLiked = false;
    this.setup();
    this.setupWindEffect();
  }

  setup() {
    this.button.addEventListener("click", () => this.handleClick());
  }

  handleClick() {
    this.isLiked = !this.isLiked;
    this.button.classList.toggle("liked");

    if (this.isLiked) {
      this.createPetals();
    }
  }

  createPetals() {
    const colors = ["#FFB6C1", "#FFC0CB", "#FFE4E1"];
    const petalCount = 15;

    for (let i = 0; i < petalCount; i++) {
      setTimeout(() => {
        const petal = this.createPetal(
          colors[Math.floor(Math.random() * colors.length)]
        );
        this.petalsContainer.appendChild(petal);
        setTimeout(() => petal.remove(), 4000);
      }, i * 150);
    }
  }

  createPetal(color) {
    const petal = document.createElement("div");
    petal.className = "petal";

    petal.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 10 10" style="transform: translate(-50%, -50%)">
        <path
          d="M5,1 C7,1 9,3 9,5 C9,7 7,9 5,9 C3,9 1,7 1,5 C1,3 3,1 5,1"
          fill="${color}"
          opacity="0.8"
        />
      </svg>
    `;

    const duration = 4 + Math.random() * 2;
    petal.style.animation = `float-wind ${duration}s ease-in-out forwards`;

    return petal;
  }

  setupWindEffect() {
    setInterval(() => {
      const root = document.documentElement;
      [1, 2, 3, 4, 5].forEach((index) => {
        const distance = 50 + Math.random() * 100;
        const angle = Math.random() * Math.PI * 2;
        root.style.setProperty(
          `--tx${index}`,
          `${Math.cos(angle) * distance}px`
        );
        root.style.setProperty(
          `--ty${index}`,
          `${Math.sin(angle) * distance}px`
        );
      });
    }, 4000);
  }
}

// 페이지 로드 시 초기화
document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".floral-like-container");
  containers.forEach((container) => new FloralAnimation(container));
});
